import React from "react";
import { Truck } from "lucide-react";

/**
 * FreshDeliveryAnimation
 * ──────────────────────
 * Minimal self-contained "delivery slip" placeholder. No real spec was
 * provided for this block — this renders a small ranch-styled shipping slip
 * so the import resolves and the page composes cleanly.
 */
export function FreshDeliveryAnimation() {
  return (
    <div className="my-6 flex justify-center" data-testid="fresh-delivery-animation">
      <div
        style={{
          width: "100%",
          maxWidth: 320,
          background: "#FFFCF5",
          border: "2px dashed #D8CFC3",
          borderRadius: 12,
          padding: "16px 18px",
          boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              backgroundColor: "var(--color-brand-greenaccent)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Truck className="w-4 h-4" style={{ color: "#fff" }} strokeWidth={2.5} />
          </div>
          <div>
            <p
              style={{
                fontSize: 12,
                fontWeight: 900,
                letterSpacing: "0.06em",
                color: "#1B2837",
                textTransform: "uppercase",
                margin: 0,
              }}
            >
              Packed Fresh &amp; On Its Way
            </p>
            <p style={{ fontSize: 11, color: "#6B6560", margin: "2px 0 0" }}>
              Made to order, shipped within the week.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
